/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RegionCreate = {
    properties: {
        name: {
            type: 'TranslationCreate',
            isRequired: true,
        },
        imageId: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        display: {
            type: 'boolean',
        },
        country: {
            type: 'CountryCode',
            isRequired: true,
        },
    },
} as const;
